




























import { IModalConfig } from '@/uikit/components/AppModal/types';
import { Header, Body, Footer } from './components';
import { defaultSettings } from '@/uikit/components/AppModal/defaultSettings';
import { position, size } from './util/index';
import resizeScreenObserver from '@/uikit/components/AppModal/mixins/resizeScreenObserver';

export default {
  name: 'AppModal',
  components: { Header, Body, Footer },

  props: {
    config: {
      type: Object as () => IModalConfig,
    },
  },
  mixins: [resizeScreenObserver],
  data() {
    return {
      tools: { position: position(), size: size() },
      header: this.getSlotData('header'),
      body: this.getSlotData('body'),
      footer: this.getSlotData('footer'),
      modalSettings: {
        ...defaultSettings,
        ...(this.config.settings ? this.config.settings : null),
        size: {
          ...defaultSettings.size,
          ...(this.config.settings
            ? this.config.settings.size
              ? this.config.settings.size
              : null
            : null),
        },
      },
    };
  },
  watch: {
    windowWidth(newWidth: any, oldWidth: any) {
      this.tools.position.setPositionByResizeScreen(newWidth);
    },
  },

  created() {
    !this.tools.size.isDesktop()
      ? this.setForcedModalParamForMobileDevice()
      : null;
    this.$nextTick(() => {
      this.initModalElementByDom();
    });
  },

  methods: {

    initModalElementByDom() {
      this.tools.position.setDomElement(this.config.name);
      this.tools.size.setDomElement(this.config.name);
      this.tools.size.setSize(this.modalSettings.size);
      const centerPosition = this.tools.position.getCenter();
      this.tools.position.setPosition(centerPosition.left, centerPosition.top);
    },
    getSlotData(key: string) {
      if (!this.config.slots) {
        return null;
      }
      return {
        component: this.config.slots[key]
          ? this.config.slots[key].component
            ? this.config.slots[key].component
            : null
          : null,
        propsData: this.config.slots[key]
          ? this.config.slots[key].propsData
            ? this.config.slots[key].propsData
            : null
          : null,
      };
    },
    close() {
      (window as any).$uiKit.$modals[this.config.name].close();
    },
    startDrag(e: any) {
      if (!this.modalSettings.isDraggable) return;
      this.tools.position.startDrag(e);
    },
    setForcedModalParamForMobileDevice() {
      this.modalSettings.isDraggable = false;
      this.modalSettings.isResize = false;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppModal/AppModal.vue